export enum DebriefingPaths {
	PERSONAL = 'personal',
	GROUP = 'group',
}
